import { RouteObject } from 'react-router-dom'

import { Panel } from 'pages/Panel/Panel'
import { Transfer } from 'pages/Panel/Containers/Transfer/Transfer'
import { Inspect } from 'pages/Panel/Containers/Inspect/Inspect'
import { Management } from 'pages/Panel/Containers/Management/Management'
import { ContainersOverview } from 'pages/Panel/Containers/Management/ContainerOverview/ContainerOverview'
import { RefillContainers } from 'pages/Panel/Containers/RefillContainers/RefillContainers'
import { ContainersOverview as EmptyContainersOverview } from 'pages/Panel/Containers/RefillContainers/ContainerOverview/ContainerOverview'
import { Transfer as SupportTransfer } from 'pages/Panel/Support/Transfer/Transfer'
import { CreateCargo } from 'pages/Panel/Support/Cargo/CreateCargo'
import { MoveContainers } from 'pages/Panel/Support/Containers/MoveContainers'
import { EmptyContainers } from 'pages/Panel/Support/EmptyContainers/EmptyContainers'

export const wmsContainers: RouteObject[] = [
  {
    path: 'v2/panel',
    Component: Panel,
    children: [
      // Перемещение.
      {
        path: 'transfer',
        children: [{ index: true, Component: Transfer }],
      },
      // Проверка.
      {
        path: 'inspect',
        children: [{ index: true, Component: Inspect }],
      },
      // Менеджмент.
      {
        path: 'management',
        children: [
          { index: true, Component: Management },
          { path: ':containerTypeId', Component: ContainersOverview },
        ],
      },
      // Курьеры.
      {
        path: 'couriers',
        children: [
          { index: true, Component: RefillContainers },
          { path: ':containerTypeId', Component: EmptyContainersOverview },
        ],
      },
      // Саппорт.
      {
        path: 'support',
        children: [
          {
            path: 'transfer',
            children: [{ index: true, Component: SupportTransfer }],
          },
          {
            path: 'cargo',
            children: [
              {
                path: 'create',
                children: [{ index: true, Component: CreateCargo }],
              },
            ],
          },
          {
            path: 'containers',
            children: [
              {
                path: 'move',
                children: [
                  { index: true, Component: MoveContainers },
                  { path: 'empty', Component: EmptyContainers },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]
